export default __webpack_public_path__ + "static/media/Ellipse174.da6a2c52.svg";